import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { CheckIcon, LoaderCircleIcon } from 'lucide-react'
import * as React from 'react'

import { cn } from '@/lib/utils'

export interface CheckboxProps extends React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> {
  variant?: 'default' | 'black'
  loading?: boolean
}

const Checkbox = React.forwardRef<React.ElementRef<typeof CheckboxPrimitive.Root>, CheckboxProps>(
  ({ className, variant = 'default', loading, ...props }, ref) => (
    <>
      {loading ? (
        <LoaderCircleIcon size={16} className={cn('animate-spin', 'text-primary')} />
      ) : (
        <CheckboxPrimitive.Root
          ref={ref}
          className={cn(
            'shrink-0',
            'peer',
            'h-4',
            'w-4',
            'rounded-sm border',
            'ring-offset-background',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
            'disabled:cursor-not-allowed disabled:opacity-50',
            {
              'border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground':
                variant === 'default',
              'data-[state=checked]:border-border-primary data-[state=checked]:bg-background-primary data-[state=checked]:text-primary-foreground':
                variant === 'black',
            },
            className
          )}
          {...props}
        >
          <CheckboxPrimitive.Indicator className={cn('flex items-center justify-center text-current')}>
            <CheckIcon className="h-4 w-4" size={16} />
          </CheckboxPrimitive.Indicator>
        </CheckboxPrimitive.Root>
      )}
    </>
  )
)
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
